// @flow
import { type I18nStrings } from './types';

const addStrings = (i18n, lng: string, strings: I18nStrings) => {
    Object.keys(strings).forEach(ns => {
        i18n.addResourceBundle(lng, ns, strings[ns], true, true);
    });
};

export default addStrings;
